import {
  SELF_ONBOARDING_PATHS,
  SELF_ONBOARDING_ROUTES,
} from "src/consts/Routes/SelfOnboarding";
import { useContext } from "react";
import FooterLinks from "../../Footer/FooterLinks";
import { ThemeValues } from "../../ThemeUsage/theme";
import { ThemeContext } from "../../ThemeUsage/ThemeUsage";
import { Route, Routes, useLocation } from "react-router-dom";
import Compatibility from "src/pages/SelfOnboarding/Compatibility";
import { Box, Container, Grid, Stack, useTheme } from "@mui/material";
import SelfOnboardingProgressBar from "../../ProgressBar/MicroFrontend/SelfOnboarding";
import BrandItemThemeChanger from "../../BrandIconThemeChanger/BrandIconThemeChanger";

const SelfOnboarding = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const themeName = useContext(ThemeContext);
  const isUserSelectEnabled = themeName !== ThemeValues.lichtblick;

  return (
    <Stack
      sx={{
        minHeight: "100vh",
        background: theme.palette.background.default,
        userSelect: isUserSelectEnabled ? undefined : "none",
      }}
    >
      <Container
        sx={{
          px: 4,
          flexGrow: 1,
          marginTop: { xs: 0, sm: 12 },
        }}
      >
        <Grid container>
          <Grid item xs={12} sm={4}>
            <Stack gap="50px">
              <Box
                sx={{
                  display: { xs: "none", sm: "flex" },
                }}
              >
                <BrandItemThemeChanger />
              </Box>
              {SELF_ONBOARDING_ROUTES.includes(pathname) && (
                <SelfOnboardingProgressBar />
              )}
            </Stack>
          </Grid>

          <Stack
            sx={{
              display: { xs: "flex", sm: "none" },
              justifyContent: "center",
              width: "100%",
              py: 2,
            }}
          >
            <BrandItemThemeChanger />
          </Stack>

          <Grid item xs={12} sm={8} sx={{ paddingLeft: { sm: 5, md: 20 } }}>
            <Routes>
              <Route
                element={<Compatibility />}
                path={SELF_ONBOARDING_PATHS.COMPATIBILITY}
              />
            </Routes>
          </Grid>
        </Grid>
      </Container>
      <FooterLinks />
    </Stack>
  );
};

export default SelfOnboarding;
